import { useMemo } from "react";
import CommonStringCell from "tables/common/CommonStringCell";
import ActionsCell from "./cells/ActionsCell";

export default function useColumns() {
  return useMemo(
    () => [
      {
        header: "Source Variable",
        accessorKey: "source_variable",
        size: 213,
        cell: CommonStringCell,
      },
      { header: "Rule", accessorKey: "rule", size: 213, cell: CommonStringCell },
      { header: "Source Value", accessorKey: "source_value", size: 213, cell: CommonStringCell },
      {
        header: "Target Variable",
        accessorKey: "target_variable",
        size: 213,
        cell: CommonStringCell,
      },
      { header: "Target Value", accessorKey: "target_value", size: 213, cell: CommonStringCell },
      {
        id: "actions",
        header: "Actions",
        size: 213,
        cell: ActionsCell,
      },
    ],
    [],
  );
}
